












































import Vue from 'vue'
import Dialog from '@/components/Dialog.vue'
import moment from 'moment'

export default Vue.extend({
  components: {
    appDialog: Dialog,
  },
  props: {
    item: {
      type: Object,
      default: () => ({} as object),
      required: false,
    },
  },
  methods: {
    formatDate(value: string) {
      moment.locale(this.$store.getters.profile.lang)
      return moment(value).format('ddd, MMM DD YYYY')
    },
  },
})
